document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cp-acc-item').forEach((item) => {
    const summary = item.querySelector('summary');
    const icon = item.querySelector('.cp-acc-icon');
    if (!summary || !icon) return;

    const sync = () => { icon.textContent = item.open ? '−' : '+'; };
    sync();

    summary.addEventListener('click', () => setTimeout(sync, 0));
  });
});
